import { useCallback, useEffect, useState } from 'react'
import { popupToast } from '@components/Notifications/popupToast'
import { StandardToast } from '@components/Notifications/StandardToast'
import { Box, BoxProps, Icon } from '@ui'
import useCopyToClipboard from 'hooks/useCopyToClipboard'
import { Paragraph } from 'ui/components/Text/Paragraph'
import { getInviteUrl } from 'ui/utils/utils'

export const ShareLinkButton = (
    props: {
        spaceId: string
        omitText?: boolean
        omitToast?: boolean
        name?: string
    } & BoxProps,
) => {
    const {
        spaceId,
        omitText,
        omitToast,
        // eslint-disable-next-line unused-imports/no-unused-vars
        name,
        ...boxProps
    } = props
    const [, copy] = useCopyToClipboard()
    const [copied, setCopied] = useState(false)

    useEffect(() => {
        if (copied) {
            const timeout = setTimeout(() => {
                setCopied(false)
            }, 3000) // Show check mark for 3 seconds
            return () => {
                clearTimeout(timeout)
            }
        }
    }, [copied])

    const onClick = useCallback(async () => {
        const url = getInviteUrl({ spaceId })
        const success = await copy(url)
        if (success) {
            setCopied(true)
            if (!omitToast) {
                popupToast(({ toast }) => (
                    <StandardToast.Success toast={toast} message="Link copied to clipboard" />
                ))
            }
        } else {
            if (!omitToast) {
                popupToast(({ toast }) => (
                    <StandardToast.Error toast={toast} message="Failed to copy link" />
                ))
            }
        }
    }, [spaceId, copy, omitToast])

    return (
        <Box
            centerContent
            horizontal
            hoverable
            color={{ default: 'gray2', hover: 'default' }}
            gap="xs"
            cursor="pointer"
            onClick={onClick}
            {...boxProps}
        >
            {copied ? (
                <Icon type="check" color="positive" size="square_md" padding="xxs" />
            ) : (
                <Icon type="share" size="square_md" padding="xxs" />
            )}
            {!omitText && <Paragraph fontWeight="medium">Share Link</Paragraph>}
        </Box>
    )
}
